import React from 'react'
import Image from "next/image";
import Link from "next/link";
import MethodologyImage from "@/images/methodology-hero.png";
import { useTranslation } from "next-i18next";

const MethodologyHero = () => {
    const { t } = useTranslation();
    return (
        <div
            id="methodology-hero"
            className="flex flex-col-reverse lg:flex-row items-center justify-between gap-[40px] lg:gap-[60px] bg-white max-w-[90%] pt-[40px] lg:pt-[80px] mx-auto"
        >
            <div className="flex-1 flex flex-col gap-[12px] md:gap-[20px] w-full min-w-[45%] max-w-full lg:max-w-[50%]">
                <div className="flex flex-col gap-[12px] md:gap-[20px]">
                    <h3 className="text-[18px] md:text-[28px] font-[600] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
                        {t("methodology-page.methodology-headline")}
                    </h3>
                    <div>
                        <h2 
                            className="text-[32px] md:text-[64px] xl:text-[76px] 2xl:text-[96px] font-[600] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]"
                            dangerouslySetInnerHTML={{ __html: t("methodology-page.methodology-hero-title") }}
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-[12px] md:gap-[20px] pr-0 xl:pr-[80px]">
                    <p className="text-[16px] lg:text-[18px] font-[500] leading-[160%] text-[#222]">
                        {t("methodology-page.methodology-hero-subtitle")}
                    </p>

                    <p className="text-[16px] lg:text-[18px] font-[400] leading-[160%] text-[#8b8b8b]">
                        {t("methodology-page.methodology-hero-description")}
                    </p>
                </div>
            </div>

            <div className=" flex flex-col items-center justify-center gap-[20px] w-full min-w-[45%] max-w-full md:max-w-[60%] lg:max-w-[50%]">
                <Image
                    src={MethodologyImage}
                    alt="About Us"
                    className="w-full"
                    priority={true}
                    fetchPriority="high"
                />
            </div>
        </div>
    )
}

export default MethodologyHero
